import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {get, set} from "lodash";
import {
    SetUserAction,
    WarningMessageAction,
    rolesConstants,
    toastActions,
    UpdateMeAction,
    LoadMeAction,
    actions
} from "mindsets-js-sdk";

import GradeField from "./GradeField";
import {AVATARS} from "constants";
import analytic from "utils/Analytic";
import useAuth from "../../hooks/useAuth";

import './profile_update.scss';

export default function () {
    useAuth(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const me = useSelector(state => state.me);
    const user = useSelector(state => state.user);
    const [submitting, setSubmitting] = useState(false);
    const [validation_error_messages, setValidationErrorMessages] = useState({});
    let user_new = JSON.parse(JSON.stringify(user));
    let validation_error_messages_new = JSON.parse(JSON.stringify(validation_error_messages));

    useEffect(() => {
        if (!!me && !user) {
            dispatch(SetUserAction(me));
        }
    }, [me]);

    function validateProfile(check_school = true) {
        if (!user_new.fname) {
            validation_error_messages_new['fname'] = 'Please enter your first name';
        }
        if (!user_new.lname) {
            validation_error_messages_new['lname'] = 'Please enter your last name';
        }
        if (check_school && user_new.persona === rolesConstants.ROLE_TEACHER && !user_new.school_id) {
            validation_error_messages_new['school'] = 'Please select your school on the next page';
        }
        if (user_new.persona === rolesConstants.ROLE_TEACHER && (!user_new.grades || user_new.grades.length <= 0)) {
            validation_error_messages_new['grade'] = 'Please select grades you teach';
        }
        setValidationErrorMessages(validation_error_messages_new);
        if (Object.keys(validation_error_messages_new).length > 0) {
            dispatch(toastActions.ErrorMessageAction('Please complete your profile.'));

            return false;
        }

        return true;
    }

    function onSave() {
        if (validateProfile(false)) {
            if (!submitting) {
                Promise.resolve()
                    .then(() => setSubmitting(true))
                    .then(() => {
                        set(user_new, 'general_data.dashboard_visited', 1);

                        return dispatch(UpdateMeAction({
                            fname: user_new.fname,
                            lname: user_new.lname,
                            general_data: user_new.general_data,
                            avatar: user_new.avatar,
                            grades: user_new.grades
                        }));
                    })
                    .then(user => {
                        analytic.log('updateUser', user);
                        analytic.log('profileComplete', user);
                    })
                    .then(() => setSubmitting(false))
                    .then(() => dispatch(LoadMeAction()))
                    .then(() => navigate('/profile'))
                    .catch(error => {
                        console.error(error);
                        dispatch(actions.LoadingAction(false));
                        dispatch(toastActions.ErrorMessageAction('We could not successfully save your data. Please try again.'));
                        setSubmitting(false);
                    });
            }
        }
    }

    function isChanged() {
        return user_new.fname !== me.fname || user_new.lname !== me.lname || user_new.avatar !== me.avatar || (me.persona === 'teacher' && Array.isArray(user_new.grades) && Array.isArray(me.grades) && user_new.grades.join(',') !== me.grades.join(','));
    }

    function renderCancel() {
        const dashboard_visited = get(me, 'general_data.dashboard_visited');
        if (!dashboard_visited) {
            return null;
        }

        return (
            <button onClick={event => {
                event.preventDefault();
                if (validateProfile()) {
                    navigate('/profile');
                }
            }} className="btn btn-flat">Cancel
            </button>
        );
    }

    function renderSaveButton() {
        if (isChanged()) {
            return (
                <button onClick={event => {
                    event.preventDefault();
                    onSave();
                }} className="btn btn-dark">SAVE
                </button>
            );
        }

        return null;
    }

    if (!user) {
        return null;
    }

    return (
        <div className="container" id='profile-update'>
            <h2 className="header-new">Update Profile</h2>

            <div className="error-messages">
                {Object.keys(validation_error_messages).length > 0 ? 'Please complete all required fields to proceed with Mindsets.' : ''}
            </div>

            <div className="profile-info section">
                <div className="row">
                    <div className="col s12 m6">
                        <label className="flex-row">
                            <div>First name *</div>
                            {
                                validation_error_messages.hasOwnProperty('fname') ?
                                    <i className="fas fa-exclamation-circle text-red ml-2"/> : null
                            }
                        </label>
                        <input
                            type="text"
                            className={validation_error_messages.hasOwnProperty('fname') ? 'invalid' : ''}
                            value={user_new.fname || ''}
                            onChange={event => {
                                let matches = event.target.value.match(/[^\w\s.\-&"':()\[\],{}’`\/?]+/um);
                                matches = [...new Set(matches)];
                                if (matches && matches.length) {
                                    validation_error_messages_new.fname = 'These characters are not allowed: ' + matches.join('');
                                    dispatch(WarningMessageAction('These characters are not allowed: ' + matches.join('')));
                                } else if (event.target.value.length >= 190) {
                                    validation_error_messages_new.fname = 'First name is too long';
                                    dispatch(WarningMessageAction('First name is too long'));
                                } else {
                                    user_new.fname = event.target.value;
                                    dispatch(SetUserAction(user_new));
                                    delete validation_error_messages_new.fname;
                                }
                                setValidationErrorMessages(validation_error_messages_new);
                            }}
                            autoComplete="off"
                            maxLength={190}
                            required/>
                    </div>

                    <div className="col s12 m6">
                        <label className="flex-row">
                            <div>Last name *</div>
                            {
                                validation_error_messages.hasOwnProperty('lname') ?
                                    <i className="fas fa-exclamation-circle text-red ml-2"/> : null
                            }
                        </label>
                        <input
                            type="text"
                            className={validation_error_messages.hasOwnProperty('lname') ? 'invalid' : ''}
                            value={user_new.lname || ''}
                            onChange={event => {
                                let matches = event.target.value.match(/[^\w\s.\-&"':()\[\],{}’`\/?]+/um);
                                matches = [...new Set(matches)];
                                if (matches && matches.length) {
                                    validation_error_messages_new.lname = 'These characters are not allowed: ' + matches.join('');
                                    dispatch(WarningMessageAction('These characters are not allowed: ' + matches.join('')));
                                } else if (event.target.value.length >= 190) {
                                    validation_error_messages_new.lname = 'Last name is too long';
                                    dispatch(WarningMessageAction('Last name is too long'));
                                } else {
                                    user_new.lname = event.target.value;
                                    dispatch(SetUserAction(user_new));
                                    delete validation_error_messages_new.lname;
                                }
                                setValidationErrorMessages(validation_error_messages_new);
                            }}
                            required
                            maxLength={190}
                            autoComplete="off"/>
                    </div>

                    <GradeField
                        validation_error_messages={validation_error_messages}
                        setValidationErrorMessages={setValidationErrorMessages}
                    />
                </div>
            </div>

            <div className="avatars">
                {AVATARS.map((avatar, index) => {
                    let classes = "avatar ";
                    if (avatar === user_new.avatar) {
                        classes += " selected";
                    }
                    let c = "cashtivity-icon " + avatar;

                    return (
                        <div className={classes} key={index} onClick={() => {
                            user_new.avatar = avatar;
                            dispatch(SetUserAction(user_new));
                        }}>
                            <div className={c}/>
                        </div>
                    );
                })}
            </div>

            <div className="flex-row flex-v-center h100 flex-h-end flex-gap-10">
                {renderCancel()}
                {renderSaveButton()}
            </div>
        </div>
    );
};
